import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import { useIsWindowWiderThan } from '@common/hooks';
import { optionDateLabel } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/optionDateLabel';
import { gridTheme } from '@utils/grid';
import moment from 'moment';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption, RoomExtraOptionPerDateType } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateForm.schema';

const optionsForPerDate = (options: RoomExtraOptionPerDateType[], isMobile: boolean) =>
  options.map((option, index) => ({
    label: optionDateLabel(moment(option.startDate).format('MMM DD'), option.name, isMobile),
    value: index,
  }));

type SelectOption = { label: string | JSX.Element; value: number };

export const PerDate = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const isMobile = !useIsWindowWiderThan(gridTheme.breakpoints.md);
  const opts = optionsForPerDate(options as RoomExtraOptionPerDateType[], isMobile);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
